import { browserHistory } from 'react-router';

export default function goToFeatureDetailPage(organizationId: string, featureKey: string) {
  return browserHistory.push(`/${organizationId}/organization/features/${featureKey}`);
}
